module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_5012.b6786978.png";